import { BAR_WEIGHT, calculatePlates, getPlateConfig, type PlateConfig } from "../utils/plateCalculator"

interface PlateStackProps {
  targetWeight: number
  barWeight?: number
  plateConfigs?: PlateConfig[]
}

function textColorForBg(hex: string) {
  const r = Number.parseInt(hex.slice(1, 3), 16)
  const g = Number.parseInt(hex.slice(3, 5), 16)
  const b = Number.parseInt(hex.slice(5, 7), 16)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.6 ? "#111" : "#fff"
}

export default function PlateStack({ targetWeight, barWeight, plateConfigs }: PlateStackProps) {
  const configs = plateConfigs ?? getPlateConfig()
  const result = calculatePlates(targetWeight, barWeight ?? BAR_WEIGHT, configs)

  if (result.plates.length === 0) {
    return null
  }

  return (
    <div className="mt-1 flex flex-col gap-0.5">
      <div className="flex items-center gap-0.5">
        <div className="flex items-center gap-px">
          {[...result.plates].reverse().map((plate, i) => (
            <div
              key={`left-${plate.weight}-${i}`}
              className="flex items-center justify-center rounded-sm font-bold text-[10px] leading-none shadow-xs"
              style={{
                backgroundColor: plate.color,
                color: textColorForBg(plate.color),
                width: `${Math.max(18, plate.weight * 0.7)}px`,
                height: `${Math.max(14, plate.weight)}px`,
              }}
            >
              {plate.weight}
            </div>
          ))}
        </div>
        <div className="mx-0.5 h-6 w-2 rounded-sm bg-muted-foreground/40" />
        <div className="flex items-center gap-px">
          {result.plates.map((plate, i) => (
            <div
              key={`right-${plate.weight}-${i}`}
              className="flex items-center justify-center rounded-sm font-bold text-[10px] leading-none shadow-xs"
              style={{
                backgroundColor: plate.color,
                color: textColorForBg(plate.color),
                width: `${Math.max(18, plate.weight * 0.7)}px`,
                height: `${Math.max(14, plate.weight)}px`,
              }}
            >
              {plate.weight}
            </div>
          ))}
        </div>
      </div>
      <div className="text-[10px] text-muted-foreground">
        {result.totalWeight} lbs
        {result.remainder > 0 && <span className="text-orange-500"> (need {result.remainder} more lbs)</span>}
      </div>
    </div>
  )
}
